import type { ComponentProps } from "react";
import { Link } from "react-router";

import { cn } from "@/utils/tailwind";

// Turn one line of text into a highlighted passage without borrowing X's mark.
//
export function LogoMark({ className, ...props }: ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-9", className)}
      fill="none"
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect className="fill-foreground" height="42" rx="14" width="42" />
      <path
        className="stroke-background"
        d="M11 13.5h20M11 28.5h15"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <path
        className="stroke-signal"
        d="M8.5 21h25"
        strokeLinecap="round"
        strokeWidth="7"
      />
      <path
        className="stroke-background"
        d="M11 21h19"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
    </svg>
  );
}

interface LogoLockupProps extends Omit<ComponentProps<typeof Link>, "to"> {
  linkTo?: string;
}

// Pair the abstract mark with the product wordmark.
//
export function LogoLockup({ className, linkTo, ...props }: LogoLockupProps) {
  const content = (
    <>
      <LogoMark className="size-9" />
      <span className="inline-flex items-baseline gap-1.5">
        <span className="font-display text-[1.3rem] font-semibold tracking-[-0.04em]">
          highlighted
        </span>
        <span className="text-signal-strong text-[0.6rem] font-bold tracking-[0.16em] uppercase">
          FYI
        </span>
      </span>
    </>
  );
  const classes = cn("inline-flex items-center gap-2.5", className);

  return linkTo ? (
    <Link className={classes} to={linkTo} {...props}>
      {content}
    </Link>
  ) : (
    <div className={classes}>{content}</div>
  );
}
